"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var useAnimateOnReorder = function useAnimateOnReorder(item, itemRef, lastReorderedQuestionId, setLastReorderedQuestionId) {
  // Theoretically, this shouldn't be needed - we should be able to use the flourish package from @atlaskit.
  // HOWEVER, that setup (as per their examples) assumes we're not rerendering after the order changes.
  // So by using the setInterval to wait until our itemRef is properly updated, THEN triggering the animation flash,
  // we have the item flashing at the location it was moved to, not in place before it was moved. This also allows us
  // to control the colour and duration, which sadly the "flourish" package doesn't expose yet.
  (0, _react.useEffect)(function () {
    if (lastReorderedQuestionId !== null && lastReorderedQuestionId === item.id) {
      var interval = setInterval(function () {
        if (itemRef.current) {
          clearInterval(interval);
          var element = itemRef.current;
          element.animate([{
            backgroundColor: 'lightblue'
          }, {}], {
            duration: 1000,
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
            iterations: 1
          });
          setLastReorderedQuestionId(null);
        }
      }, 100); // Check every 100ms
    }
  }, [itemRef.current, lastReorderedQuestionId]);
};

var _default = exports["default"] = useAnimateOnReorder;